import { render, staticRenderFns } from "./BigPerformance.vue?vue&type=template&id=54426bb3&"
import script from "./BigPerformance.vue?vue&type=script&lang=js&"
export * from "./BigPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports